<head>
    <link rel="preconnect" href="https://fonts.gstatic.com">
    <link href="https://fonts.googleapis.com/css2?family=Manrope:wght@300;400;500;600&display=swap" rel="stylesheet">
</head>

<mat-drawer-container #matDrawerContainer class="sidenav-container animated-gradient-bg">
    <mat-drawer #drawer [mode]="'side'" class="sidenav" opened>
        <div style="display: flex; justify-content: center;">
            <img class="logo" mat-list-item src="../assets/image/logo-black.svg" alt="ПОЧ">
        </div>

        <div style="display: flex;
        flex-direction: column;
        align-items: center;">
            <mat-divider style="margin-top: 3vh; margin-bottom: 3vh; width: 90%;"></mat-divider>
        </div>

        <div style="display: flex;justify-content: center;">
            <mat-accordion #sideNavContent class="app-nav-accordion">
                <mat-nav-list class="sidebarMenu" (click)="windowDimensions.width < windowDimensions.threshold_sm ? closeSidenav() : null">
                    <a mat-list-item routerLink="/dashboard/home" [routerLinkActive]="['is-active']">
                        <i class="text-[1.2rem] md:text-[1.25rem]" style=" margin: 2vh;" class="fa-regular fa-house"></i>
                        <div  class="text-[1.2rem] md:text-[1.25rem]">{{"Home" | translate}}</div>
                    </a>

                    <a mat-list-item routerLink="/dashboard/term" [routerLinkActive]="['is-active']">
                        <i class="text-[1.2rem] md:text-[1.25rem]" style=" margin: 2vh;" class="fa-regular fa-calendar-range"></i>
                        <div  class="text-[1.2rem] md:text-[1.25rem]">{{"Terms schedule" | translate}}</div>
                    </a>

                    <a mat-list-item routerLink="/dashboard/service" [routerLinkActive]="['is-active']">
                        <i class="text-[1.2rem] md:text-[1.25rem]" style=" margin: 2vh;" class="fa-regular fa-id-card"></i>
                        <div  class="text-[1.2rem] md:text-[1.25rem]">{{"Services" | translate}}</div>
                    </a>

                    <a mat-list-item routerLink="/dashboard/shift" [routerLinkActive]="['is-active']">
                        <i class="text-[1.2rem] md:text-[1.25rem]" style=" margin: 2vh;" class="fa-regular fa-clock"></i>
                        <div  class="text-[1.2rem] md:text-[1.25rem]">{{"Shifts schedule" | translate}}</div>
                    </a>

                    <a mat-list-item routerLink="/dashboard/memberships" [routerLinkActive]="['is-active']">
                        <i class="text-[1.2rem] md:text-[1.25rem]" style=" margin: 2vh;" class="fa-light fa-dumbbell"></i>
                        <div  class="text-[1.2rem] md:text-[1.25rem]">{{"Memberships" | translate}}</div>
                    </a>

                    <a mat-list-item routerLink="/dashboard/users" [routerLinkActive]="['is-active']">
                        <i class="text-[1.2rem] md:text-[1.25rem]" style=" margin: 2vh;" class="fa-regular fa-users"></i>
                        <div  class="text-[1.2rem] md:text-[1.25rem]">{{"menu-item-users" | translate}}</div>
                    </a>

                    <a mat-list-item routerLink="/dashboard/configuration" [routerLinkActive]="['is-active']">
                        <i class="text-[1.2rem] md:text-[1.25rem]" style=" margin: 2vh;" class="fa-regular fa-cogs"></i>
                        <div  class="text-[1.2rem] md:text-[1.25rem]">{{"Configuration" | translate}}</div>
                    </a>

                    <a mat-list-item href="https://cms.vacuactivskopje.mk/admin/content-manager/collection-types/api::device.device?page=1&pageSize=10&sort=DeviceName:ASC" target="_blank">
                        <i class="text-[1.2rem] md:text-[1.25rem]" style="margin: 2.55vh;" class="fa-regular fa-file-lines"></i>
                        <div class="text-[1.2rem] md:text-[1.25rem]">{{"Strapi" | translate}}</div>
                    </a>
                </mat-nav-list>

                <mat-nav-list class="sidebarMenu">

                    <div class="alternativeBtn">
                        <a mat-list-item (click)="openChangePasswordModal()" [routerLinkActive]="['is-active']">
                            <i class="text-[1.2rem] md:text-[1.25rem]" style=" margin: 2vh;" class="fa-regular fa-key"></i>
                            <div  class="text-[1.2rem] md:text-[1.25rem]">{{ "Change-Password" | translate }}</div>
                        </a>

                        <a mat-list-item (click)="logout()" [routerLinkActive]="['is-active']">
                            <i class="text-[1.2rem] md:text-[1.25rem]" style=" margin: 2vh;" class="fa-regular fa-right-from-bracket"></i>
                            <div  class="text-[1.2rem] md:text-[1.25rem]">
                            {{"Logout" | translate}}
                        </div>
                    </a>

                    </div>
                </mat-nav-list>
            </mat-accordion>
        </div>
    </mat-drawer>

    <mat-drawer-content>
        
        <div class="box width_100_percent appheader" id='appheader'>
            <mat-toolbar color="primary">
                <div class="toolbar-header">
                    <div class="pic">
                        <div class="userButtons">
                            <button mat-icon-button style="padding-right: 5vh;" (click)="toggleSidenav()">
                                <svg height="32px" id="Layer_1" style="enable-background:new 0 0 32 32;" version="1.1"
                                    viewBox="0 0 32 32" width="32px" xml:space="preserve"
                                    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <path
                                        d="M4,10h24c1.104,0,2-0.896,2-2s-0.896-2-2-2H4C2.896,6,2,6.896,2,8S2.896,10,4,10z M28,14H4c-1.104,0-2,0.896-2,2  s0.896,2,2,2h24c1.104,0,2-0.896,2-2S29.104,14,28,14z M28,22H4c-1.104,0-2,0.896-2,2s0.896,2,2,2h24c1.104,0,2-0.896,2-2  S29.104,22,28,22z" />
                                </svg>
                            </button>

                             <div class="userInfo">
                                <span style="color: #00000058; font-size: 10px;">{{ "Welcome" | translate }}</span>
                                <span
                                    style="color: #000; font-size: 16px; display: block; margin: 0;">{{userData!.name}}
                                    {{userData!.surname}}</span>
                            </div> 

                        </div>
                    </div>
                                     
                    <div class="vid">
                        <div class="flex flex-row gap-3 items-center">
                            <button 
                            *ngIf="windowDimensions.width > windowDimensions.threshold_lg"
                            class="changePassword" mat-button (click)="openChangePasswordModal()">
                                {{ "Change-Password" | translate }}
                            </button>
                            <span   *ngIf="windowDimensions.width > windowDimensions.threshold_lg" style="border-left: 2px solid #afafaf; height: 3rem"></span>
                            <button 
                            *ngIf="windowDimensions.width > windowDimensions.threshold_lg"
                             mat-button class="flex flex-row items-center" (click)="logout()" aria-label="Logout" style="color: #000; vertical-align: bottom;">
                                <i class="fa-sharp fa-regular fa-arrow-right-from-bracket text-[1.7rem] mr-2"></i>
                                {{ "Logout" | translate }}
                            </button>
                        </div>
                    </div>       

                    <app-generic-modal
                    *ngIf="showChangePasswordPopup"
                    [modal_state_function]="closeChangePasswordModal"
                    [handle_mobile]="false"
                    (handleCloseEmitter)="closeChangePasswordModal()"
                    [bannerText]="'changePassword' | translate "
                    >     
                    <form #form="ngForm">
                            <div class="sm:w-[30rem] center-items">
                                <mat-form-field class="w-[80%]">
                                    <mat-label>{{ 'oldPassword' | translate }}</mat-label>
                                    <input matInput type="password" [(ngModel)]="oldPassword" name="oldPassword" required>
                                </mat-form-field>
                                <mat-form-field class="w-[80%]">
                                    <mat-label>{{ 'newPassword' | translate }}</mat-label>
                                    <input matInput type="password" [(ngModel)]="newPassword" name="newPassword" required minlength="9">
                                </mat-form-field>
                                <mat-form-field class="w-[80%]">
                                    <mat-label>{{ 'confirmPassword' | translate }}</mat-label>
                                    <input matInput type="password" [(ngModel)]="confirmPassword" name="confirmPassword" required minlength="9">
                                </mat-form-field>
                                <button class="btnPassSave" mat-raised-button color="primary" [disabled]="!form.valid"  (click)="savePassword(oldPassword ?? '', newPassword ?? '', confirmPassword ?? ''); closeChangePasswordModal()">{{ 'Save' | translate }}</button>
                            </div>     
                        </form>             
                    </app-generic-modal>      

                </div>

            </mat-toolbar>

        </div>
        
        <router-outlet></router-outlet>

    </mat-drawer-content> 
</mat-drawer-container>
